export const cmsIcons = [
  { label: "none", value: "" },
  { label: "Flash", value: "flash" },
  { label: "Infinity", value: "infinity" },
  { label: "Award 03", value: "award-03" },
  { label: "Badge", value: "badge" },
  { label: "Bookmark", value: "bookmark" },
  { label: "Lightbulb 05", value: "lightbulb-05" },
  { label: "Clock Check", value: "clock-check" },
  { label: "Calendar Check 01", value: "calendar-check-01" },
  { label: "Chat", value: "chat" },
  { label: "Play Circle", value: "play-circle" },
  { label: "Play", value: "play" },
  { label: "Chart Breakout Circle", value: "chart-breakout-circle" },
  { label: "Bar Chart 12", value: "bar-chart-12" },
  { label: "Check Heart", value: "check-heart" },
  { label: "Users Check", value: "users-check" },
  { label: "Face Wink", value: "face-wink" },
  { label: "Building 07", value: "building-07" },
  { label: "Stars 01", value: "stars-01" },
  { label: "Stars 02", value: "stars-02" },
  { label: "Trophy 01", value: "trophy-01" },
  { label: "Book Open 01", value: "book-open-01" },
  { label: "Message Question Circle", value: "message-question-circle" },
  { label: "Message Chat Circle", value: "message-chat-circle" },
  { label: "Magic Wand 01", value: "magic-wand-01" },
  { label: "Heart Hand", value: "heart-hand" },
  { label: "Check Verified 02", value: "check-verified-02" },
  { label: "Key 01", value: "key-01" },
  { label: "Clock Refresh", value: "clock-refresh" },
  { label: "Coins Hand", value: "coins-hand" },
  { label: "User Check 01", value: "user-check-01" },
  { label: "Pen Tool 01", value: "pen-tool-01" },
  { label: "Book Closed", value: "book-closed" },
  { label: "Users 03", value: "users-03" },
  { label: "Phone", value: "phone" },
  { label: "Life Buoy 02", value: "life-buoy-02" },
  { label: "Whatsapp", value: "whatsapp" },
  { label: "Building 08", value: "building-08" },
  { label: "Hearth Hand", value: "hearth-hand" },
  { label: "Mail 01", value: "mail-01" },
  { label: "Mail 02", value: "mail-02" },
  { label: "Counseling", value: "counseling" },
  { label: "Live Course", value: "live-course" },
  { label: "Answered Question", value: "answered-question" },
  { label: "Mock Test Club", value: "mock-test-club" },
  { label: "Group Counseling", value: "group-counseling" },
  { label: "Subject Video", value: "subject-video" },
  { label: "Question Answer", value: "question-answer" },
  { label: "Parent Counseling", value: "parent-counseling" },
  { label: "Mock Test Set", value: "mock-test-set" },
  { label: "Mock Tests", value: "mock-tests" },
];
